import React, { useState, useCallback } from "react";
import { Button, Modal } from 'react-bootstrap';
import { NotificationManager } from "react-notifications";
import axios from "axios"; // Assurez-vous que axios est importé

export default function AddOtherSkills({ idCv }) {
    const [show, setShow] = useState(false);
    const [skill, setSkill] = useState({
        loisir: ''
    });

    // Gestion du changement des champs
    const handleChange = (e) => {
        const { name, value } = e.target;
        setSkill(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    // Validation basique du formulaire
    const validateForm = () => {
        if (!skill.loisir) {
            NotificationManager.warning('Veuillez entrer une compétence.', 'Erreur', 4000);
            return false;
        }
        return true;
    };

    // Enregistrement des données
    const handleExp = useCallback(async () => {
        if (!validateForm()) return;

        const formData = new FormData();
        formData.append('loisir', skill.loisir);
        formData.append('cv_id', idCv);

        try {
            const resp = await axios.post('loisirs', formData);
            if (resp.status === 201) {
                NotificationManager.success('Information enregistrée avec succès', 'Succès', 4000);
                setShow(false); // Fermer la modal après succès
                setSkill({ loisir: '' }); // Réinitialiser le formulaire après enregistrement
            } else {
                NotificationManager.warning('Une erreur est survenue lors de l\'enregistrement.', 'Erreur', 4000);
            }
        } catch (error) {
            NotificationManager.error("Une erreur est survenue lors de l'enregistrement.", 'Erreur', 4000);
            console.error(error);
        }
    }, [skill, idCv]);

    return (
        <>
            <Button variant="info" onClick={() => setShow(true)}>
                <b>+</b> Ajouter d'autres compétences
            </Button>

            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Ajouter d'autres compétences</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="form-group">
                            <label htmlFor="loisir" className="form-label">Compétence</label>
                            <input
                                id="loisir"
                                name="loisir"
                                required
                                value={skill.loisir}
                                onChange={handleChange}
                                maxLength={50}
                                className="form-control mb-2"
                                type="text"
                                placeholder="Votre compétence"
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={handleExp}>
                        Enregistrer
                    </Button>
                    <Button variant="secondary" onClick={() => setShow(false)}>
                        Fermer
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
